import React from "react";
import ErrorScreen from "./ErrorScreen";

class ErrorBoundary extends React.Component {
    state = { hasError: null };

    static getDerivedStateFromError(error) {
        return { hasError: error };
    }

    componentDidCatch(error, info) {
        console.info(error, info);
    }

    render() {
        if(this.state.hasError !== null) {
            return <ErrorScreen error={this.state.hasError} />
        }

        return this.props.children;
    }
}

export default ErrorBoundary;